export const getBackgroundCSS = (bg, isSolid = true, isGradient = true, isImage = true) => {
    const { type = 'solid', color = '#000000b3', gradient = 'linear-gradient(135deg, #4527a4, #8344c5)', image = {}, position = 'center center', attachment = 'initial', repeat = 'no-repeat', size = 'cover', overlayColor = '#000000b3' } = bg;

    const styles = ('gradient' === type && isGradient) ? `background: ${gradient};` :
        ('image' === type && isImage) ?
            `background: url(${image?.url});
				background-color: ${overlayColor};
				background-position: ${position};
				background-size: ${size};
				background-repeat: ${repeat};
				background-attachment: ${attachment};
				background-blend-mode: overlay;` :
            isSolid && `background: ${color};`;

    return styles;
}

export const getBorderCSS = (border) => {
    const { width = '0px', style = 'solid', color = '#0000', side = 'all', radius = '0px' } = border;

    const borderSideCheck = s => {
        const bSide = side?.toLowerCase();
        return bSide?.includes('all') || bSide?.includes(s);
    }

    const noWidth = width === '0px' || !width;
    const borderCSS = `${width} ${style} ${color}`;

    const styles = `
		${noWidth ? '' : borderSideCheck('top') ? `border-top: ${borderCSS};` : ''}
		${noWidth ? '' : borderSideCheck('right') ? `border-right: ${borderCSS};` : ''}
		${noWidth ? '' : borderSideCheck('bottom') ? `border-bottom: ${borderCSS};` : ''}
		${noWidth ? '' : borderSideCheck('left') ? `border-left: ${borderCSS};` : ''}
		${!radius ? '' : `border-radius: ${radius};`}
	`;

    return styles;
}

export const getColorsCSS = (colors) => {
    const { color = '#333', bgType = 'solid', bg = '#0000', gradient = 'linear-gradient(135deg, #4527a4, #8344c5)' } = colors;

    const styles = `
		${color ? `color: ${color};` : ''}
		${gradient || bg ? `background: ${'gradient' === bgType ? gradient : bg};` : ''}
	`;

    return styles;
}

export const getIconCSS = (icon, isSize = true, isColor = true) => {
    const { fontSize = 16, colorType = 'solid', color = 'inherit', gradient = 'linear-gradient(135deg, #4527a4, #8344c5)' } = icon;

    const colorCSS = 'gradient' === colorType ?
        `color: transparent; background-image: ${gradient}; -webkit-background-clip: text; background-clip: text;` :
        `color: ${color};`;

    const styles = `
		${!fontSize || !isSize ? '' : `font-size: ${fontSize}px;`}
		${isColor ? colorCSS : ''}
	`;

    return styles;
}

export const getMultiShadowCSS = (value, type = 'box') => {
    const { shadow = [{ hOffset: '0px', vOffset: '0px', blur: '0px', spreed: '0px', color: '#7090b0', isInset: false }] } = value;

    let styles = '';

    shadow?.map((item, index) => {
        const { hOffset, vOffset, blur, spreed, color, isInset } = item;

        const inset = isInset ? 'inset' : '';
        const offsetBlur = `${hOffset || ''} ${vOffset || ''} ${blur || ''}`;
        const isComa = index + 1 >= shadow.length ? '' : ', ';

        styles += 'text' === type ? `${offsetBlur} ${color || ''}${isComa}` : `${offsetBlur} ${spreed || ''} ${color || ''} ${inset}${isComa}`;
    });

    return styles;
}

export const getSeparatorCSS = (separator) => {
    const { width = '50%', height = '2px', style = 'solid', color = '#bbb' } = separator;

    const styles = `
		width: ${width};
		${'0px' === height && '0em' === height && '0rem' === height ? '' : `border-top: ${height} ${style} ${color};`}
	`;

    return styles;
}

export const getShadowCSS = (shadow) => {
    const { type = 'box', hOffset = '0px', vOffset = '0px', blur = '0px', spreed = '0px', color = '#7090b0', isInset = false } = shadow;

    const inset = isInset ? 'inset' : '';
    const offsetBlur = `${hOffset} ${vOffset} ${blur}`;

    const styles = 'text' === type ? `${offsetBlur} ${color}` : `${offsetBlur} ${spreed} ${color} ${inset}`;

    return styles;
}

export const getSpaceCSS = (space) => {
    const { side = 2, vertical = '0px', horizontal = '0px', top = '0px', right = '0px', bottom = '0px', left = '0px' } = space;

    const styles = 2 === side ? `${vertical} ${horizontal}` : `${top} ${right} ${bottom} ${left}`;

    return styles;
}

export const getTypoCSS = (typo, isFamily = true) => {
    const { fontFamily = 'Default', fontCategory = 'sans-serif', fontVariant = 400, fontWeight = 400, fontSize = 15, fontStyle = 'normal', textTransform = 'none', textDecoration = 'auto', lineHeight = '135%', letterSpace = '0px' } = typo;

    const generateCss = (value, cssProperty) => !value ? '' : `${cssProperty}: ${value};`;

    const allStyles = `
		${(!isFamily || !fontFamily) || ('Default' === fontFamily) ? '' : `font-family: '${fontFamily}', ${fontCategory};`}
		${generateCss(fontWeight, 'font-weight')}
		${!fontSize ? '' : `font-size: ${fontSize}px;`}
		${generateCss(fontStyle, 'font-style')}
		${generateCss(textTransform, 'text-transform')}
		${generateCss(textDecoration, 'text-decoration')}
		${generateCss(lineHeight, 'line-height')}
		${generateCss(letterSpace, 'letter-spacing')}
	`;

    // Google font link
    const linkQuery = !fontVariant || 400 === fontVariant ? '' : '400i' === fontVariant ? ':ital@1' : fontVariant?.includes('00i') ? `: ital, wght@1, ${fontVariant?.replace('00i', '00')} ` : `: wght@${fontVariant} `;

    const link = 'Default' === fontFamily || !fontFamily ? '' : `https://fonts.googleapis.com/css2?family=${fontFamily?.split(' ').join('+')}${linkQuery.replace(/ /g, '')}&display=swap`;

    return { styles: allStyles.replace(/\s+/g, ' ').trim(), googleFontLink: link };
}